//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment from 'moment';
export default {
  name: 'LogMessageList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  data: function data() {
    return {
      pagePath: '/sys/log/message',
      pageTitle: '通讯日志',
      times: [],
      // 表头
      isorter: {
        column: 'time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        dataIndex: 'st_dictText',
        colName: 'st',
        title: '系统类型',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'cn',
        colName: 'cn',
        title: '命令编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'time',
        colName: 'time',
        title: '上传时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'clientIp',
        colName: 'client_ip',
        title: '客户端IP',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'clientPort',
        colName: 'client_port',
        title: '客户端端口',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'serverIp',
        colName: 'server_ip',
        title: '服务端IP',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '报文类别',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'handleDesc_dictText',
        colName: 'handle_desc',
        title: '处理结果',
        align: 'center',
        sorter: true
      }],
      autoLoadInit: false
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.queryParam.timeStart = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.timeEnd = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss');
    this.times = [moment(this.queryParam.timeStart, 'YYYY-MM-DD HH:mm:ss'), moment(this.queryParam.timeEnd, 'YYYY-MM-DD HH:mm:ss')];
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
      this.getPages(1, 100);
    }
  },
  computed: {},
  methods: {
    onDateTime: function onDateTime(value, dateArray) {
      console.log(value, dateArray);
      this.queryParam.timeStart = dateArray[0];
      this.queryParam.timeEnd = dateArray[1];
    },
    loadData: function loadData(arg) {
      var ids = this.getTreeCurrentId();
      this.queryParam.queryType = ids[0];
      this.queryParam.queryId = ids[1];

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.initTableData(arg);
    }
  }
};